export default __webpack_public_path__ + "images/MD.8d7d695.png";